export default function CsharpArrays() {
  return (
    <h2>Csharp Arrays</h2>
  );
}
